import { BackTo } from '@components/util/BackToPage';
import { AppPage } from '@pages/AppPage';
import { serviceWorkerService } from '@services/ServiceWorkerService';
import { billingStore } from '@stores/Billing';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

export const UpdateCreditsLeftPage = observer(() => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    const refreshCredits = async () => {
      setIsRefreshing(true);
      setMessage('Refreshing credits...');

      try {
        // Refresh credits on this tab
        await billingStore.refetchCreditsAfterOperation();

        // Broadcast to other tabs via service worker
        await serviceWorkerService.postMessage({
          type: 'REFRESH_CREDITS',
        });

        setMessage(`Credits refreshed! Current credits: ${billingStore.creditsLeft ?? 'N/A'}`);
      } catch (error) {
        console.error('Error refreshing credits:', error);
        setMessage('Error refreshing credits. Check console for details.');
      } finally {
        setIsRefreshing(false);
      }
    };

    refreshCredits();
  }, []);

  return (
    <AppPage header={<BackTo useBrowserHistory>Update Credits</BackTo>} gradientBackground={true}>
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Update Credits Left</h2>
        {isRefreshing ? (
          <p>Refreshing credits...</p>
        ) : (
          <>
            <p>{message || 'Credits refresh completed'}</p>
            <p style={{ marginTop: '1rem', fontSize: '1.2rem', fontWeight: 'bold' }}>
              Current Credits: {billingStore.creditsLeft ?? 'N/A'}
            </p>
            <p style={{ marginTop: '1rem', color: '#666', fontSize: '0.9rem' }}>
              All open tabs have been notified to refresh their credits.
            </p>
          </>
        )}
      </div>
    </AppPage>
  );
});
